import React from "react";
import PropTypes from "prop-types";

import CircleButton from "core/CircleButton";
import Tooltip from "core/Tooltip";

import Reset from "core/ReusableIcons/Reset";

import colors from "core/colors";

const EditorReset = ({ handleClick, isDisabled }) => {
    return (
        <Tooltip message="Reset" size="small">
            <CircleButton
                type="button"
                styleType="secondary"
                size="sm"
                icon={<Reset size="sm" fillColor={colors.secondary.oolong} />}
                title="reset color picker"
                onClick={handleClick}
                isDisabled={isDisabled}
            />
        </Tooltip>
    );
};

EditorReset.propTypes = {
    handleClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
};

export default React.memo(EditorReset);
